import SearchFormFieldGroup from 'components/SearchV2/Components/SearchFormField/SearchFormFieldGroup'
import React, { useMemo } from 'react'
import { connect } from 'react-redux'
import Group from 'components/utils/Group'
import LineUserIcon from 'LuxKit/Icons/line/LineUserIcon'
import AssistChip from 'LuxKit/Chips/AssistChip'

interface MappedStateProps {
  businessAccount?: App.BusinessTraveller.CurrentBusinessAccount
}

interface Props {
  className?: string;
}

function BusinessTravellerSelectHotelsDesktopDisabled(props: Props & MappedStateProps) {
  const {
    className,
    businessAccount,
  } = props

  const travellerName = useMemo(() => {
    if (!businessAccount?.employee) {
      return 'Travellers'
    }
    const { firstName = '', lastName = '' } = businessAccount.employee
    return `${firstName} ${lastName}`.trim() || 'Travellers'
  }, [businessAccount?.employee])

  return (
    <SearchFormFieldGroup className={className}>
      <Group direction="horizontal" gap={12} wrap="wrap">
        <AssistChip
          variant="outline"
          size="medium"
          startIcon={<LineUserIcon />}
          disabled
        >
          Travellers: <b>{travellerName}</b>
        </AssistChip>
        <AssistChip
          variant="outline"
          size="medium"
          disabled
        >
          1 room
        </AssistChip>
      </Group>
    </SearchFormFieldGroup>
  )
}

export default connect<MappedStateProps, {}, Props, App.State>((state) => {
  return {
    businessAccount: state.businessTraveller.currentBusinessAccount,
  }
})(BusinessTravellerSelectHotelsDesktopDisabled)
